import { useState } from "react";
import { useEditTeamMutation, useGetTeamsQuery } from "../../features/teams/teamsApi";
import { useGetUsersQuery } from "../../features/users/usersApi";

export default function AddTeamUserModal({ open, control, teamId }) {
    const [teamUsers, setTeamUsers] = useState("");
    const {data: users} = useGetUsersQuery();
    const {data: teams} = useGetTeamsQuery();
    const [addUserToTeam] = useEditTeamMutation();

    const handleSubmit = (e) => {
        e.preventDefault();

        const team = teams.find(team => team?.id?.toString() === teamId.toString());
        const newTeamUsers = teamUsers.map(teamuser => {
            const existingUser = users.find(user => teamuser.toString() === user?.id?.toString());
            return {
                id : existingUser?.id,
                name: existingUser?.name,
                email : existingUser?.email
            };
        });

        const data = {
            ...team,
            users: [...team.users, ...newTeamUsers]
        };

        addUserToTeam({
            id: teamId,
            data
        });

        control();
    };

    return (
        open && (
            <>
                <div
                    onClick={control}
                    className="fixed w-full h-full inset-0 z-10 bg-black/50 cursor-pointer"
                ></div>
                <div className="rounded w-[400px] lg:w-[600px] space-y-8 bg-white p-10 absolute top-1/2 left-1/2 z-20 -translate-x-1/2 -translate-y-1/2">
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                        Add Team Users
                    </h2>
                    <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
                        <div className="rounded-md shadow-sm -space-y-px">
                            <div>
                                <select className="form-select appearance-none
                                    block
                                    w-full
                                    px-3
                                    py-1.5
                                    text-base
                                    font-normal
                                    text-gray-700
                                    bg-white bg-clip-padding bg-no-repeat
                                    border border-solid border-gray-300
                                    rounded
                                    transition
                                    ease-in-out
                                    mt-2
                                    focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" aria-label="Default select example"
                                    multiple
                                    onChange={e => {
                                        const values = [...e.target.selectedOptions].map(user => user.value);
                                        setTeamUsers(values);
                                    }}
                                >
                                    {users && users
                                                ?.filter(user => !teams.find(team => team.users.find(existingUser => team?.id?.toString() === teamId?.toString() && existingUser?.id?.toString() === user?.id?.toString())))
                                                ?.map(user => 
                                        <option key = {user.id} value = {user.id}>{user.name}</option>
                                    )}
                                </select>
                            </div>
                        </div>

                        <div>
                            <button
                                type="submit"
                                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
                            >
                                Add Users
                            </button>
                        </div>
                    </form>
                </div>
            </>
        )
    );
}
